import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentGateway, PaymentVerificationResult} from '@features/payment/domain/model/payment.model';
import {Payment} from '@features/payment/domain/entities/payment.entity';

export interface PaymentStrategy {
  checkout(payments: Payment[]): Observable<string>;
  verify(payment: Payment): Observable<PaymentVerificationResult>;
}

export interface PaymentStrategyRegistry {
  resolve(gateway: PaymentGateway): PaymentStrategy;
}

export const PAYMENT_STRATEGY_REGISTRY = new InjectionToken<PaymentStrategyRegistry>('PAYMENT_STRATEGY_REGISTRY');
